import './IconText.scss';

import Icon from 'components/Icon/Icon';
import type { ReactNode } from 'react';
import React from 'react';

interface Props {
  iconPath: string;
  text: ReactNode;
  className?: string;
  iconType?: 'success' | 'danger';
}

const IconText: React.FC<Props> = (props): React.ReactElement => {
  return (
    <div className={`IconText ${props.className || ''}`}>
      <div className="IconText_inner">
        <span>
          <Icon className={`IconText_icon ${props.iconType || ''}`} path={props.iconPath} />
        </span>
        <span className="IconText_text">{props.text}</span>
      </div>
    </div>
  );
};

export default IconText;
